<template>
    <div class="i-wysiwyg">
        <modal name="wysiwyg-editor" :height="600" width="800" padding='4'>
            <span slot="title">
                <icon name="pencil" /> Редактор Wysiwyg</span>
            <!-- <textarea  :value="value" @change='onChange'/> -->
            <div class="container">
                <vue-mce v-model="content" :init="cfg" @onInit="onLoadContent" @onSave="onChange" />
            </div>
        </modal>
    </div>
</template>
<script>
import Editor from '@tinymce/tinymce-vue';
import tinyRu from './tinymce_ru.js';
export default {
    components: {
        'vue-mce': Editor
    },
    name: 'i-wysiwyg-service',
    props: {
        value: String,
        label: String
    },

    mounted() {
        let self = this;
        _i.bus.$on('edit-wysiwyg', ({ idx, content }) => {
            self.idx = idx;
            self.content = content;
            this.openModal('wysiwyg-editor');
        });
    },
    methods: {
        onLoadContent() {
            tinyMCE.addI18n('ru', tinyRu);
            tinyMCE.init({
                language: 'ru'
            });
        },
        onChange(v) {
            this.$emit('input', v.target.value.replace(/\n/gim, ""));
        },
        onMessage(e) {},
        edit() {}
    },
    computed: {
        cfg() {
            let self = this;
            return {
                height: "410",
                remove_linebreaks: true,
                force_p_newlines: false,

                menu: {
                    edit: { title: 'Edit', items: 'undo redo  | cut copy paste selectall | searchreplace' },
                    insert: { title: 'Insert', items: 'link charmap' },
                    format: { title: 'Format', items: 'bold italic underline strikethrough superscript subscript | removeformat' },
                    table: { title: 'Table', items: 'inserttable tableprops deletetable | cell row column' }
                },
                image_title: true,
                image_advtab: true,
                style_formats: [{
                        title: 'Image Left',
                        selector: 'img',
                        styles: {
                            'float': 'left',
                            'margin': '0 10px 0 10px'
                        }
                    },
                    {
                        title: 'Image Right',
                        selector: 'img',
                        styles: {
                            'float': 'right',
                            'margin': '0 10px 0 10px'
                        }
                    }
                ],

                formats: {
                    //alignleft: { selector: 'p,h1,h2,h3,h4,h5,h6,td,th,div,ul,ol,li,table,img', classes: 'left' },
                    //aligncenter: { selector: 'p,h1,h2,h3,h4,h5,h6,td,th,div,ul,ol,li,table,img', classes: 'center' },
                    //alignright: { selector: 'p,h1,h2,h3,h4,h5,h6,td,th,div,ul,ol,li,table,img', classes: 'right' },
                    alignfull: { selector: 'p,h1,h2,h3,h4,h5,h6,td,th,div,ul,ol,li,table,img', classes: 'full' },
                    //bold: { inline: 'span', 'classes': 'bold' },
                    //italic: { inline: 'span', 'classes': 'italic' },
                    //underline: { inline: 'span', 'classes': 'underline', exact: true },
                    //strikethrough: { inline: 'del' }
                },

                plugins: "save image table   textcolor fullscreen charmap  link hr lists paste",
                toolbar: 'save | fullscreen | charmap |  link | hr | undo redo | fontselect formatselect forecolor backcolor | bold italic underline | link hr | alignleft aligncenter alignright alignjustify | blockquote bullist numlist outdent indent | code | image | table ',
                save_onsavecallback: function(v) {
                    self.closeModal("wysiwyg-editor");
                    _i.bus.$emit('save-wysiwyg', { idx: self.idx, content: self.content.replace(/\n/gim, "") });
                    // self.$emit('input', self.content);
                },
                images_upload_handler: function(blobInfo, success, failure) {
                    console.log("IAMGE GMEAGF")
                    var formData = new FormData();
                    //formData.append("file", file);
                    formData.append('file', blobInfo.blob(), blobInfo.filename());

                    var request = new XMLHttpRequest();
                    request.open("POST", "//" + location.hostname + (location.port ? ':' + location.port : '') + "/api/v1/upload");
                    request.withCredentials = true;

                    request.onload = function(oEvent) {
                        if (request.status == 200) {
                            console.log("UPLOADED!", request.response);
                            let data = JSON.parse(request.response);
                            let { url, name, ext, size } = data;
                            success(url);
                        } else {
                            failure("ERROR ON UPLOAD")
                        }
                    };
                    request.send(formData);
                }

            }
        }
    },
    data() {
        let self = this;
        return {
            idx: 0,
            content: "",
            opened: false,
            frame_src: '',
            buffer: ""
        }
    }
}
</script>
<style lang="css" scoped>
.editor-frame {
    width: 100%;
    height: 100%;
    border: none;
}
</style>